/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import CurrentPlanCard from './index/current-plan-card';
import { hasScheduledChanges } from 'state/current-universal-importer/selectors';
import ScheduledChangesCard from './index/scheduled-changes';
import { Stack, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';

/**
 * Style dependencies
 */
import './styles.scss';

const UniversalImporter = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage Universal Importer Plan - Tower Systems' />
            <Topbar title='Universal Importer Plan' subTitle='Manage your Universal Importer plan' selected='universal-importer'>

            </Topbar>
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Your current Universal Importer plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentPlanCard />
                            {props.hasScheduledChanges && <ScheduledChangesCard />}
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {},
)(UniversalImporter);
